import { Building2, FileText, ListChecks, Users } from "lucide-react";
import { lazy } from "react";

import type { TabRoute } from "@/lib/routes";

// Lazy-load each tab so opening a supplier only pulls the active tab's chunk.
// Tab components default-export their named component for React.lazy.
const SupplierOverviewTab = lazy(() => import("./SupplierOverviewTab"));
const SupplierContactsTab = lazy(() => import("./SupplierContactsTab"));
const SupplierCodificationTab = lazy(() => import("./SupplierCodificationTab"));
const SupplierDocumentsTab = lazy(() => import("./SupplierDocumentsTab"));

/**
 * Child tab routes for `/suppliers/:id`. Exported here (not inline in
 * `lib/routes.tsx` / `lib/global-routes.tsx`) so `SupplierDetailPage` can
 * import the list directly without a circular import through `NAV_RECORDS`.
 */
export const SUPPLIER_TAB_ROUTES: ReadonlyArray<TabRoute> = [
  {
    path: "overview",
    label: "Overview",
    icon: Building2,
    element: <SupplierOverviewTab />,
  },
  {
    path: "contacts",
    label: "Contacts",
    icon: Users,
    element: <SupplierContactsTab />,
  },
  {
    path: "codification",
    label: "Codification",
    icon: ListChecks,
    element: <SupplierCodificationTab />,
  },
  {
    // A blank contract is a supplier document; it only arrived alongside the
    // price matrix by accident of delivery. Everything operational about matrix
    // pricing lives on the cross-supplier surface under Operations.
    path: "documents",
    label: "Documents",
    icon: FileText,
    element: <SupplierDocumentsTab />,
    requiredPermission: "matrix_pricing.view",
  },
];
